import { MerchantAccountLinkOutput } from '@allocab/allocab-driver-shared-types';
import { useMutation } from '@tanstack/react-query';

import { driverApi } from '../services/network/Api';

const fetchMerchantAccountDashboardLink = () =>
  driverApi.get<void, MerchantAccountLinkOutput>('/v1/merchant/account/link/dashboard');

export const useFetchMerchantAccountDashboardLink = () =>
  useMutation({ mutationFn: fetchMerchantAccountDashboardLink });
